import request from "./http.js";
import { apiBase } from "@/config/api.js";

// 封装post请求;
function postRequest(url, data = {}) {
  return request({
    method: "post",
    url: url,
    data: data,
    // 可以添加额外配置，如请求头、响应处理等
    headers: {
      "Content-Type": "application/json",
    },
    skipAuthRedirect: true,
  });
}

// 用户登录
export const loginFn = (params) => postRequest(apiBase + "/login", params);

// 用户登出：调后端把当前 token 加入黑名单（服务端撤销）。
// 走 request 实例，自动带上 Authorization 头。
export const logoutFn = () =>
  request({
    url: apiBase + "/yt-sys/logout",
    method: "post",
  });

// 获取登录图形验证码：返回 { captcha_id, captcha_image (data URL), expires_in }
export const getCaptchaFn = () => request.get(apiBase + "/captcha");

// ========== 用户管理API ==========

// 获取用户列表
export function getUserList(params) {
  return request({
    url: apiBase + "/yt-sys/admin/users",
    method: "get",
    params,
  });
}

// 获取用户详情
export function getUserDetail(id) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}`,
    method: "get",
  });
}

// 创建用户
export function createUser(data) {
  return request({
    url: apiBase + "/yt-sys/admin/users",
    method: "post",
    data,
  });
}

// 更新用户
export function updateUser(id, data) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}`,
    method: "put",
    data,
  });
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}`,
    method: "delete",
  });
}

// 批量删除用户
export function batchDeleteUsers(ids) {
  return request({
    url: apiBase + "/yt-sys/admin/users/batch",
    method: "delete",
    data: { ids },
  });
}

// 更新用户状态
export function updateUserStatus(id, status) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}/status`,
    method: "put",
    data: { status },
  });
}
// 给用户分配资源 (项目和设备)
export function assignAssets(data) {
  return request({
    url: apiBase + "/yt-sys/admin/users/assign",
    method: "post",
    data,
  });
}

// 获取用户已分配的资源
export function getUserAssets(id) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}/assets`,
    method: "get",
  });
}

// 获取当前管理员可分配给子账号的项目和设备全集
export function getAssignableAssets() {
  return request({
    url: apiBase + "/yt-sys/admin/assignable-assets",
    method: "get",
  });
}

export function getCurrentPagePermissions() {
  return request({
    url: apiBase + "/yt-sys/user/page-permissions",
    method: "get",
  });
}

export function getUserPagePermissions(id) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}/page-permissions`,
    method: "get",
  });
}

export function updateUserPagePermissions(id, pageKeys, actionKeys) {
  return request({
    url: apiBase + `/yt-sys/admin/users/${id}/page-permissions`,
    method: "put",
    data: { page_keys: pageKeys, action_keys: actionKeys },
  });
}

export function getPermissionRoles() {
  return request({
    url: apiBase + "/yt-sys/admin/permission-roles",
    method: "get",
  });
}

export function createPermissionRole(data) {
  return request({
    url: apiBase + "/yt-sys/admin/permission-roles",
    method: "post",
    data,
  });
}

export function updatePermissionRole(id, data) {
  return request({
    url: apiBase + `/yt-sys/admin/permission-roles/${id}`,
    method: "put",
    data,
  });
}

export function deletePermissionRole(id) {
  return request({
    url: apiBase + `/yt-sys/admin/permission-roles/${id}`,
    method: "delete",
  });
}

export function assignPermissionRole(roleId, userIds) {
  return request({
    url: apiBase + "/yt-sys/admin/permission-roles/assign-users",
    method: "put",
    data: { role_id: roleId, user_ids: userIds },
  });
}

// ========== 个人资料API ==========

// 获取当前用户信息
export function getUserProfile() {
  return request({
    url: apiBase + "/yt-sys/user/profile",
    method: "get",
  });
}

// 更新当前用户信息
export function updateUserProfile(data) {
  return request({
    url: apiBase + "/yt-sys/user/profile",
    method: "put",
    data,
  });
}

// ========== 告警通知配置API ==========

// 获取告警通知配置列表
export function getAlarmNotifyConfigs() {
  return request({
    url: apiBase + "/yt-sys/alarm-notify/configs",
    method: "get",
  });
}

// 创建告警通知配置
export function createAlarmNotifyConfig(data) {
  return request({
    url: apiBase + "/yt-sys/alarm-notify/configs",
    method: "post",
    data,
  });
}

// 更新告警通知配置
export function updateAlarmNotifyConfig(id, data) {
  return request({
    url: apiBase + `/yt-sys/alarm-notify/configs/${id}`,
    method: "put",
    data,
  });
}

// 删除告警通知配置
export function deleteAlarmNotifyConfig(id) {
  return request({
    url: apiBase + `/yt-sys/alarm-notify/configs/${id}`,
    method: "delete",
  });
}

// ========== 操作审计日志API ==========

// 查询操作日志
export function getOperationLogs(params) {
  return request({
    url: apiBase + "/yt-sys/operation-logs",
    method: "get",
    params,
  });
}

// 查询访问日志（账号登录历史）
export function getAccessLogs(params) {
  return request({
    url: apiBase + "/yt-sys/access-logs",
    method: "get",
    params,
  });
}
